import {BackendApi} from '@/services/backend_api'

export const GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID = 'cac508fb-205c-3e51-ae14-d4f8b0ba5c83'

export default {
  get (parkId) {
    return BackendApi.getClient().get(`general-informations/?parkId=${parkId}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  post (parkId) {
    return BackendApi.getClient().post(`general-informations/`, { parkId, quizTemplateUuid: GENERAL_INFORMATIONS_QUIZ_TEMPLATE_UUID })
      .then(response => { return response })
      .catch(e => { throw e })
  },
  put (uuid, answers) {
    return BackendApi.getClient().put(`general-informations/${uuid}`, { answers })
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/general_information.js